const ROUTES = {
  HOME: '/',
  LOGIN: '/autentificare',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  CHANGE_PASS: '/parola',
  INSTITUTION: '/institutie',
  REPORTS: '/raportare',
  DECISIONS: '/monitorizare',
  DECISION: '/pagina-monitorizare',
  DECISION_PAGE: '/monitorizare/',
  // ADD_DECISION: '/adaugare-monitorizare',
  ACCOUNTS: '/conturi',
  LITIGATION_NOTIFICATIONS: '/notificari-litigii',
  AUDITS_NOTIFICATIONS: '/notificari-audit',
  CALENDAR: '/calendar',
  NOTIFICATIONS: '/notificari',
  LEGISLATION: '/legislatie',
  ADMIN_DECISIONS: '/administrare-monitorizare',
  ADMIN_REPORTS: '/administrare-rapoarte',
  REDIRECT: '/signin-oidc',
  /* admin routes */
  MANAGE_ACCOUNTS: '/administrare-conturi',
  MANAGE_LEGISLATION: '/administrare-legislatie',
  MANAGE_NOTIFICATIONS: '/administrare-notificari',
  /* tutorial */
  TUTORIAL: '/tutorial',
  PRIVACY_POLICY: '/politica-de-confidentialitate',
  TERMS_AND_CONDITIONS: '/termeni-si-conditii',
  DATA_PROCESSING_AGREEMENT: '/acord-prelucrare-date',
  PDF: '/vizualizare-document/',
  LITIGII: '/litigii',
  LITIGATION_DOWNLOAD: '/litigation-document/:id',
  LITIGII_DETAILS: '/litigii/:id',
  ACCEPT_REQ: '/confirm-institution/:id',
  REJECT_REQ: '/reject-institution/:id',
  /* Control Reports - Files */
  CCR_REPORT: '/CcrReport/:id',
  ADDITIONAL_DOCUMENT: '/AdditionalDocuments/:id',
  FOLLOW_UP_CCR_REPORT: '/FollowupCcrReport/:id',
  /* achizitii publice */
  ACHIZITII: '/achizitii-publice'
};

export { ROUTES };
